import React from 'react';

import './index.scss'

export default function BudgetListItem({item, color}) {
  return (
    <div className="budgetListItem">
      <div
        style={{
          border: `3px solid ${color}`,
          width: '20px',
          background: `${color}`,
        }}
      ></div>
      <p className="mb-0">{item.value}%</p>
      <p className="mb-0">{item.sector}</p>
    </div>
  );
}
